import React from 'react';
import { CTAComponent } from 'Common/UI/client/components/CTA';
import { RelatedContentProps, RelatedContentItem } from './models';
import './styles.scss';

const RelatedContent: React.FC<RelatedContentProps> = ({ data }) => {
  if (!data) {
    return null;
  }
  // Add missing fields with default values
  // data.eyebrow = data.eyebrow || '';
  // data.readTimeText = data.readTimeText;
  // Ensure each manual content item has required fields
  if (data.manualContentItems) {
    for (const key of Object.keys(data.manualContentItems)) {
      const item = data.manualContentItems[key];
      item.readTime = item.readTime || '5';
      item.publishDate = item.publishDate || new Date().toISOString();
      item.bodyCopy = item.bodyCopy || '';
    }
  }

    // Determine layout based on number of items instead of data layout option
  const getLayoutClass = (itemCount: number) => {
    return `layout-grid-${itemCount}`;
  };
  // Convert manualContentItems object to array
  const contentItems = Object.values(data.manualContentItems) as RelatedContentItem[];
  const cardLayoutClass = getLayoutClass(contentItems.length);

  // Format date
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  // Generate image URL from dynamic media reference
  const getImageUrl = (fileReference: any) => {
    if (!fileReference) return '';
    if (typeof fileReference === 'object' && fileReference.assetName) {
      const assetName = fileReference.assetName;
      if (typeof assetName === 'string' && assetName.startsWith('/images/')) {
        return assetName;
      }
      return `/images/gehealthcarestage/${assetName}`;
    }
    // Fallback to default image if assetName is missing
    return '';
  };
  return (
    <div 
      className="ge-related-content" 
  data-bgcolor={data.bgColor}
    >
      <div className="cmp-bg-color fullwidth"></div>
      <div className="ge-related-content-container">
        {/* Header */}
  {(data.eyebrow || data.title) && (
          <div className="ge-related-content-header">
            {data.eyebrow && (
              <div className="ge-related-content-header-eyebrow">
                <span className="text-eyebrow" dangerouslySetInnerHTML={{ __html: data.eyebrow }} />
              </div>
            )}
            {data.title && (
              <div className="ge-related-content-header-title">
                <h2 className="title-m" dangerouslySetInnerHTML={{ __html: data.title }} />
              </div>
            )}
          </div>
        )}
        {/* Cards */}
        <div className={`ge-related-content-cards ${cardLayoutClass}`}>
          {contentItems.map((item, index) => {
            const cardContent = (
              <>
                {/* Card Media */}
                <div className="ge-related-content-card-media">
                  {/* Image Media */}
                  {item.mediaType === 'image' && (
                    <div className="ge-related-content-card-media-wraper hover-zoom-media">
                      <img 
                        src={getImageUrl(item.fileReference)}
                        alt={item.altText || 'Card Image'}
                        loading="lazy"
                        style={{ width: '100%', height: 'auto', aspectRatio: '16/9', objectFit: 'cover' }}
                      />
                    </div>
                  )}
                </div>
                {/* Card Body */}
                {(item.headline || item.bodyCopy) && (
                  <div className="ge-related-content-card-body">
                    {item.headline && (
                      <div className="ge-related-content-card-body-title">
                        <h3 className="text-paragraph" dangerouslySetInnerHTML={{ __html: item.headline }} />
                      </div>
                    )}
                    {item.bodyCopy && (
                      <div className="ge-related-content-card-body-copy">
                        <div className="text-paragraph-s" dangerouslySetInnerHTML={{ __html: item.bodyCopy }} />
                      </div>
                    )}
                  </div>
                )}
                {/* Card Metadata */}
                {(item.publishDate || item.readTime) && (
                  <div className="ge-related-content-card-metadata">
                    {item.publishDate && (
                      <div className="ge-related-content-card-metadata-publishdate text-caption">
                        {formatDate(item.publishDate)}
                      </div>
                    )}
                    {item.publishDate && item.readTime && (
                      <div className="ge-related-content-card-metadata-seperator text-caption">&nbsp;&nbsp;•&nbsp;&nbsp;</div>
                    )}
                    {item.readTime && (
                      <div className="ge-related-content-card-metadata-watchtime text-caption">
                        {item.readTime} {data.readTimeText}
                      </div>
                    )}
                  </div>
                )}
              </>
            );

            return item.mediaType === 'image' && item.imageLink ? (
              <a
                key={`${item.headline}-${item.publishDate}`}
                id={`ge-related-content-card_${index}`}
                href={item.imageLink}
                target={item.linkTarget}
                className={`ge-related-content-card hover-zoom clickable`}
                style={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
              >
                {cardContent}
              </a>
            ) : (
              <div
                key={`${item.headline}-${item.publishDate}`}
                id={`ge-related-content-card_${index}`}
                className={`ge-related-content-card hover-zoom`}
              >
                {cardContent}
              </div>
            );
          })}
        </div>
        {/* CTA Link */}
        {data.text && data.url && (
          <div className="ge-related-content-link">
            <CTAComponent
              href={data.url}
              target={data.target}
              style={data.style}
              text={data.text}
              svgContent={data.icon}
              suffixIcon={data.suffixIcon === 'true'}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export { RelatedContent };

